export enum BillStatus {
  BilledOut = 'Billed Out',
  New = 'New',
  Paid = 'Paid',
  Received = 'Received',
}
